export const topbarButtons = [
    { format: "strong", label: "B", title: "Bold" },
    { format: "emphasis", label: "I", title: "Italic" },
    { format: "code", label: "</>", title: "Code" },
];
